import { render } from "./RegistrationLoginData.vue?vue&type=template&id=a1a6c5a6&ts=true"
import script from "./RegistrationLoginData.vue?vue&type=script&lang=ts"
export * from "./RegistrationLoginData.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__